import { prop, filter, flow, sortBy, compact } from 'lodash/fp'

import { Organization, OrganizationData } from '../types'
import { PerformanceIndicatorType, PerformanceIndicator } from '../../performanceIndicators/types'
import { getCurrentFundingRound, getFundingRoundCommittedInvestorsAsPerformanceIndicator } from './common'
import { OrganizationEvent } from '../../organizationEvents/types'

export function getOrganizationPerformanceIndicators({
  performanceIndicators,
}: Organization | OrganizationData): PerformanceIndicator[] {
  return performanceIndicators || []
}

export function getOrganizationEvents({ events }: Organization | OrganizationData): OrganizationEvent[] {
  return events || []
}

export const getOrganizationMonthlyRevenues = flow(
  getOrganizationPerformanceIndicators,
  filter(({ type }) => type === PerformanceIndicatorType.monthlyRevenue),
  sortBy<PerformanceIndicator>(prop('measuredOn'))
)

export const getOrganizationCommittedCapital = flow(
  getOrganizationPerformanceIndicators,
  filter(({ type }) => type === PerformanceIndicatorType.committedCapital),
  sortBy<PerformanceIndicator>(prop('measuredOn'))
)

export const getOrganizationCommittedInvestorsUpdates = flow(
  getOrganizationPerformanceIndicators,
  filter(({ type }) => type === PerformanceIndicatorType.committedInvestors),
  sortBy<PerformanceIndicator>(prop('measuredOn'))
)

function getCurrentFundingRoundInitialCommittedInvestors(organizationLike: Organization) {
  const currentFundingRound = getCurrentFundingRound(organizationLike)
  if (!currentFundingRound) {
    return undefined
  }
  const initialCommittedInvestors = getFundingRoundCommittedInvestorsAsPerformanceIndicator(currentFundingRound)
  return initialCommittedInvestors
}

export function getOrganizationCommittedInvestors(organizationLike: Organization) {
  const initialCommittedInvestors = getCurrentFundingRoundInitialCommittedInvestors(organizationLike)
  const committedInvestorsUpdates = getOrganizationCommittedInvestorsUpdates(organizationLike)
  return compact([initialCommittedInvestors, ...committedInvestorsUpdates])
}
